import React, { useState } from "react";
import "./Tooltip.css";
import { toolTip } from '../../constants'

const Tooltip = (props) => {
  let timeout;
  const [active, setActive] = useState(false);
  const [packType, setPackType] = useState("");


  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 100);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
        <div className={`Tooltip-Tip ${props.direction || "right"}`}>
          {toolTip && toolTip.map((res, key) => {
            return (

              res.usecaseProfileName == props.usecaseProfileName &&
              <>
                {res.start_date && <p className="tooltip_p"><span style={{ fontWeight: "600" }}>Start Date :</span>{res.start_date}</p>}
                {res.duration && <p className="tooltip_p"><span style={{ fontWeight: "600" }}>Duration :</span>{res.duration}</p>}
                {res.periodicity && <p className="tooltip_p"><span style={{ fontWeight: "600" }}>Periodicity :</span>{res.periodicity}</p>}
                {res.time && <p className="tooltip_p"><span style={{ fontWeight: "600" }}>Time :</span> {res.time}</p>}
                {res.message_body && <p className="tooltip_p"><span style={{ fontWeight: "600" }}>Message Body :</span>{res.message_body}</p>}

              </>
            )
          })}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
